export interface ICountryList {
  value: string;
  label: string;
}

export const CountryList: ICountryList[] = [
  { value: "AD", label: "Andorra" },
  { value: "AE", label: "Sameinuðu arabísku furstadæmin" },
  { value: "AF", label: "Afganistan" },
  { value: "AG", label: "Antígva og Barbúda" },
  { value: "AI", label: "Angvilla" },
  { value: "AL", label: "Albanía" },
  { value: "AM", label: "Armenía" },
  { value: "AO", label: "Angóla" },
  { value: "AQ", label: "Suðurskautslandið" },
  { value: "AR", label: "Argentína" },
  { value: "AS", label: "Bandaríska Samóa" },
  { value: "AT", label: "Austurríki" },
  { value: "AU", label: "Ástralía" },
  { value: "AW", label: "Arúba" },
  { value: "AX", label: "Álandseyjar" },
  { value: "AZ", label: "Aserbaídsjan" },
  { value: "BA", label: "Bosnía og Hersegóvína" },
  { value: "BB", label: "Barbados" },
  { value: "BD", label: "Bangladess" },
  { value: "BE", label: "Belgía" },
  { value: "BF", label: "Búrkína Fasó" },
  { value: "BG", label: "Búlgaría" },
  { value: "BH", label: "Barein" },
  { value: "BI", label: "Búrúndí" },
  { value: "BJ", label: "Benín" },
  { value: "BL", label: "Sankti Bartólómeusareyja" },
  { value: "BM", label: "Bermúdaeyjar" },
  { value: "BN", label: "Brúnei" },
  { value: "BO", label: "Bólivía" },
  { value: "BQ", label: "Bonaire, Sint Eustatius og Saba" },
  { value: "BR", label: "Brasilía" },
  { value: "BS", label: "Bahamaeyjar" },
  { value: "BT", label: "Bútan" },
  { value: "BV", label: "Bouveteyja" },
  { value: "BW", label: "Botsvana" },
  { value: "BY", label: "Hvíta-Rússland" },
  { value: "BZ", label: "Belís" },
  { value: "CA", label: "Kanada" },
  { value: "CC", label: "Kókoseyjar" },
  { value: "CD", label: "Lýðstjórnarlýðveldið Kongó" },
  { value: "CF", label: "Mið-Afríkulýðveldið" },
  { value: "CG", label: "Lýðveldið Kongó" },
  { value: "CH", label: "Sviss" },
  { value: "CI", label: "Fílabeinsströndin" },
  { value: "CK", label: "Cookseyjar" },
  { value: "CL", label: "Chile" },
  { value: "CM", label: "Kamerún" },
  { value: "CN", label: "Kína" },
  { value: "CO", label: "Kólumbía" },
  { value: "CR", label: "Kostaríka" },
  { value: "CU", label: "Kúba" },
  { value: "CV", label: "Grænhöfðaeyjar" },
  { value: "CW", label: "Cúracao" },
  { value: "CX", label: "Jólaeyja" },
  { value: "CY", label: "Kýpur" },
  { value: "CZ", label: "Tékkland" },
  { value: "DE", label: "Þýskaland" },
  { value: "DJ", label: "Djíbútí" },
  { value: "DK", label: "Danmörk" },
  { value: "DM", label: "Dóminíka" },
  { value: "DO", label: "Dóminíska lýðveldið" },
  { value: "DZ", label: "Alsír" },
  { value: "EC", label: "Ekvador" },
  { value: "EE", label: "Eistland" },
  { value: "EG", label: "Egyptaland" },
  { value: "EH", label: "Vestur-Sahara" },
  { value: "ER", label: "Erítrea" },
  { value: "ES", label: "Spánn" },
  { value: "ET", label: "Eþíópía" },
  { value: "FI", label: "Finnland" },
  { value: "FJ", label: "Fídjieyjar" },
  { value: "FK", label: "Falklandseyjar" },
  { value: "FM", label: "Míkrónesía" },
  { value: "FO", label: "Færeyjar" },
  { value: "FR", label: "Frakkland" },
  { value: "GA", label: "Gabon" },
  { value: "GB", label: "Bretland" },
  { value: "GD", label: "Grenada" },
  { value: "GE", label: "Georgía" },
  { value: "GF", label: "Franska Gvæjana" },
  { value: "GG", label: "Guernsey" },
  { value: "GH", label: "Gana" },
  { value: "GI", label: "Gíbraltar" },
  { value: "GL", label: "Grænland" },
  { value: "GM", label: "Gambía" },
  { value: "GN", label: "Gínea" },
  { value: "GP", label: "Gvadelúpeyjar" },
  { value: "GQ", label: "Miðbaugs-Gínea" },
  { value: "GR", label: "Grikkland" },
  { value: "GS", label: "Suður-Georgía og Suður-Sandvíkseyjar" },
  { value: "GT", label: "Gvatemala" },
  { value: "GU", label: "Gvam" },
  { value: "GW", label: "Gínea-Bissá" },
  { value: "GY", label: "Gvæjana" },
  { value: "HK", label: "Hong Kong" },
  { value: "HM", label: "Heard og McDonaldseyjar" },
  { value: "HN", label: "Hondúras" },
  { value: "HR", label: "Króatía" },
  { value: "HT", label: "Haítí" },
  { value: "HU", label: "Ungverjaland" },
  { value: "ID", label: "Indónesía" },
  { value: "IE", label: "Írland" },
  { value: "IL", label: "Ísrael" },
  { value: "IM", label: "Mön" },
  { value: "IN", label: "Indland" },
  { value: "IO", label: "Bresku Indlandshafseyjar" },
  { value: "IQ", label: "Írak" },
  { value: "IR", label: "Íran" },
  { value: "IS", label: "Ísland" },
  { value: "IT", label: "Ítalía" },
  { value: "JE", label: "Jersey" },
  { value: "JM", label: "Jamaíka" },
  { value: "JO", label: "Jórdanía" },
  { value: "JP", label: "Japan" },
  { value: "KE", label: "Kenía" },
  { value: "KG", label: "Kirgistan" },
  { value: "KH", label: "Kambódía" },
  { value: "KI", label: "Kíribatí" },
  { value: "KM", label: "Kómoreyjar" },
  { value: "KN", label: "Sankti Kitts og Nevis" },
  { value: "KP", label: "Norður-Kórea" },
  { value: "KR", label: "Suður-Kórea" },
  { value: "KW", label: "Kúveit" },
  { value: "XK", label: "Kosóvó" },
  { value: "KY", label: "Caymaneyjar" },
  { value: "KZ", label: "Kasakstan" },
  { value: "LA", label: "Laos" },
  { value: "LB", label: "Líbanon" },
  { value: "LC", label: "Sankti Lúsía" },
  { value: "LI", label: "Liechtenstein" },
  { value: "LK", label: "Srí Lanka" },
  { value: "LR", label: "Líbería" },
  { value: "LS", label: "Lesótó" },
  { value: "LT", label: "Litháen" },
  { value: "LU", label: "Lúxemborg" },
  { value: "LV", label: "Lettland" },
  { value: "LY", label: "Líbýa" },
  { value: "MA", label: "Marokkó" },
  { value: "MC", label: "Mónakó" },
  { value: "MD", label: "Moldóva" },
  { value: "ME", label: "Svartfjallaland" },
  { value: "MF", label: "Sankti Martin (franski hlutinn)" },
  { value: "MG", label: "Madagaskar" },
  { value: "MH", label: "Marshalleyjar" },
  { value: "MK", label: "Norður-Makedónía" },
  { value: "ML", label: "Malí" },
  { value: "MM", label: "Mjanmar" },
  { value: "MN", label: "Mongólía" },
  { value: "MO", label: "Makaó" },
  { value: "MP", label: "Norður-Maríanaeyjar" },
  { value: "MQ", label: "Martiník" },
  { value: "MR", label: "Máritanía" },
  { value: "MS", label: "Montserrat" },
  { value: "MT", label: "Malta" },
  { value: "MU", label: "Máritíus" },
  { value: "MV", label: "Maldíveyjar" },
  { value: "MW", label: "Malaví" },
  { value: "MX", label: "Mexíkó" },
  { value: "MY", label: "Malasía" },
  { value: "MZ", label: "Mósambík" },
  { value: "NA", label: "Namibía" },
  { value: "NC", label: "Nýja Kaledónía" },
  { value: "NE", label: "Níger" },
  { value: "NF", label: "Norfolkeyja" },
  { value: "NG", label: "Nígería" },
  { value: "NI", label: "Níkaragva" },
  { value: "NL", label: "Holland" },
  { value: "NO", label: "Noregur" },
  { value: "NP", label: "Nepal" },
  { value: "NR", label: "Nárú" },
  { value: "NU", label: "Niue" },
  { value: "NZ", label: "Nýja Sjáland" },
  { value: "OM", label: "Óman" },
  { value: "PA", label: "Panama" },
  { value: "PE", label: "Perú" },
  { value: "PF", label: "Franska Pólýnesía" },
  { value: "PG", label: "Papúa Nýja-Gínea" },
  { value: "PH", label: "Filippseyjar" },
  { value: "PK", label: "Pakistan" },
  { value: "PL", label: "Pólland" },
  { value: "PM", label: "Sankti Pierre og Miquelon" },
  { value: "PN", label: "Pitcairn" },
  { value: "PR", label: "Púertó Ríkó" },
  { value: "PS", label: "Palestína" },
  { value: "PT", label: "Portúgal" },
  { value: "PW", label: "Palá" },
  { value: "PY", label: "Paragvæ" },
  { value: "QA", label: "Katar" },
  { value: "RE", label: "Réunion" },
  { value: "RO", label: "Rúmenía" },
  { value: "RS", label: "Serbía" },
  { value: "RU", label: "Rússland" },
  { value: "RW", label: "Rúanda" },
  { value: "SA", label: "Sádi-Arabía" },
  { value: "SB", label: "Salómonseyjar" },
  { value: "SC", label: "Seychelleseyjar" },
  { value: "SD", label: "Súdan" },
  { value: "SE", label: "Svíþjóð" },
  { value: "SG", label: "Singapúr" },
  { value: "SH", label: "Sankti Helena" },
  { value: "SI", label: "Slóvenía" },
  { value: "SJ", label: "Svalbarði og Jan Mayen" },
  { value: "SK", label: "Slóvakía" },
  { value: "SL", label: "Síerra Leóne" },
  { value: "SM", label: "San Marínó" },
  { value: "SN", label: "Senegal" },
  { value: "SO", label: "Sómalía" },
  { value: "SR", label: "Súrínam" },
  { value: "SS", label: "Suður-Súdan" },
  { value: "ST", label: "Saó Tóme og Prinsípe" },
  { value: "SV", label: "El Salvador" },
  { value: "SX", label: "Sint Maarten (hollenski hlutinn)" },
  { value: "SY", label: "Sýrland" },
  { value: "SZ", label: "Svasíland" },
  { value: "TC", label: "Turks- og Caicoseyjar" },
  { value: "TD", label: "Tsjad" },
  { value: "TF", label: "Frönsku suðlægu landsvæðin" },
  { value: "TG", label: "Tógó" },
  { value: "TH", label: "Taíland" },
  { value: "TJ", label: "Tadsjikistan" },
  { value: "TK", label: "Tókelá" },
  { value: "TL", label: "Austur-Tímor" },
  { value: "TM", label: "Túrkmenistan" },
  { value: "TN", label: "Túnis" },
  { value: "TO", label: "Tonga" },
  { value: "TR", label: "Tyrkland" },
  { value: "TT", label: "Trínidad og Tóbagó" },
  { value: "TV", label: "Túvalú" },
  { value: "TW", label: "Taívan" },
  { value: "TZ", label: "Tansanía" },
  { value: "UA", label: "Úkraína" },
  { value: "UG", label: "Úganda" },
  { value: "UM", label: "Bandarísku ytri eyjar" },
  { value: "US", label: "Bandaríkin" },
  { value: "UY", label: "Úrúgvæ" },
  { value: "UZ", label: "Úsbekistan" },
  { value: "VA", label: "Vatíkanið" },
  { value: "VC", label: "Sankti Vincent og Grenadíneyjar" },
  { value: "VE", label: "Venesúela" },
  { value: "VG", label: "Bresku Jómfrúaeyjar" },
  { value: "VI", label: "Bandarísku Jómfrúaeyjar" },
  { value: "VN", label: "Víetnam" },
  { value: "VU", label: "Vanúatú" },
  { value: "WF", label: "Wallis- og Fútúnaeyjar" },
  { value: "WS", label: "Samoa" },
  { value: "YE", label: "Jemen" },
  { value: "YT", label: "Mayotte" },
  { value: "ZA", label: "Suður-Afríka" },
  { value: "ZM", label: "Sambía" },
  { value: "ZW", label: "Simbabve" },
];
